import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

import { ReactComponent as SmallChat } from "../../Assets/icons/small-chats-icons.svg";
import { ReactComponent as SmallPhone } from "../../Assets/icons/small-phone-icons.svg";
import { ReactComponent as ChatNameIcon } from "../../Assets/icons/chatNameInputIcon.svg";
import { ReactComponent as Globe } from "../../Assets/iconsv2/sidebar/GlobeIcon.svg"
import { useAuthService } from '../../Context/AuthContext';
import LanguageBtn from '../Auth Components/LanguageBtn';
import { useTranslate,useTolgee } from '@tolgee/react';
import PrimaryButton from '../GenericComponents/PrimaryButton';
import { INTERFACE_TRANSLATION_LANGUAGES } from '../../Constants/constantValues';
import LocalStorage from "../../Helpers/LocalStorage";


const OnboardMeetingAnnonymousUser = ({ requestToJoin, meeting, handleMeetingHasEnded }) => {
  const { t } = useTranslate();
  const tolgee = useTolgee();

  const { translationsLanguages, callTranslationsLanguages, getCallTranslationsLanguages, getTranslationsLanguages } = useAuthService();

  const [name, setName] = useState("")
  const [language, setLanguage] = useState();
  const [interfaceLanguage, setInterfaceLanguage] = useState(tolgee.getLanguage());
  const [callLanguage, setCallLanguage] = useState();

  const handleNameChange = (e) => {
    const { value } = e.currentTarget
    setName(value);
  }

  useEffect(() => {
    getCallTranslationsLanguages(() => { }, () => { });
    getTranslationsLanguages(() => { }, () => { });
  }, [])
  return (
    <Container>
      <Content>
        <Card>
          <GroupTitle>
            <h1>{t('onboardingPage.app_preference')}</h1>
            <p>{t('meeting_onboard.meeting_subtitle')}</p>
          </GroupTitle>
          <Group>
            <GroupDescription>
              <GroupDescriptionText>{t('general.interface_language')}</GroupDescriptionText>
            </GroupDescription>
            <LanguageBtn
              value={interfaceLanguage }
              setValue={(value) => {
                setInterfaceLanguage(value);
                tolgee.changeLanguage(value);
                LocalStorage.setInterfaceLanguage(value);
              }}
              valuesList={INTERFACE_TRANSLATION_LANGUAGES}
              placeholder={
                t('general.interface_language_placeholder')
              }
              placeholderIcon={<Globe />}
              callLanguage
            />
          </Group>
          <Group>
            <GroupDescription>
              <GroupDescriptionText>{t('register.chat_language')}</GroupDescriptionText>
            </GroupDescription>
            <LanguageBtn
              value={language}
              setValue={setLanguage}
              valuesList={translationsLanguages}
              placeholder={
                t('register.chat_language_placeholder')
              }
              placeholderIcon={<SmallChat />}
            />
          </Group>
          <Group>
            <GroupDescription>
              <GroupDescriptionText>{t('onboardingPage.calls_language')}</GroupDescriptionText>
            </GroupDescription>
            <LanguageBtn
              value={callLanguage}
              setValue={setCallLanguage}
              valuesList={callTranslationsLanguages}
              placeholder={
                t('onboardingPage.select_calls_placeholder')
              }
              placeholderIcon={<SmallPhone />}
              callLanguage
            />
          </Group>
          <Group>
            <GroupDescription>
              <GroupDescriptionText>{t('general.your_name')}</GroupDescriptionText>
            </GroupDescription>
            <CustomInputWrapper>
              <ChatNameIcon />
              <input
                placeholder={t('register.name_placeholder')}
                onChange={(e) => handleNameChange(e)}
                value={name}
                name="name"
                maxLength={100}
              />
            </CustomInputWrapper>
          </Group>

          <Group style={{ alignItems: 'center', justifyContent: "center" }}>
            <PrimaryButton
              style={{ padding: "16px", width: "100%" }}
              disabled={
                name.length < 3 ||
                !language ||
                !callLanguage ||
                !interfaceLanguage
              }
              id="name-continue-button"
              onClick={(e) => requestToJoin(meeting.id, name, callLanguage, language)}
            >
              {t('meeting_onboard.request_to_join_meeting')}
            </PrimaryButton>
            <CancelBtn onClick={() => handleMeetingHasEnded()}>{t('general.cancel')}</CancelBtn>
          </Group>
        </Card>

      </Content>
    </Container>
  )
}

export default OnboardMeetingAnnonymousUser


const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  height: 100%;
  width: 100%;
  align-items: center;
  position: relative;
  overflow: hidden;
  background:${({ theme }) => theme.menu.background};
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
  gap: 40px;
  margin:auto;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  h1 {
    color:${({ theme }) => theme.menu.primaryTextColor};
    font-size: 32px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: left;
  }

`;
const CustomInputWrapper = styled.div`
  display: flex;
  width: 100%;
background:${({ theme }) => theme.menu.groupContentBackground};
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  gap: 10px;

  input {
    width: 100%;
    color:${({ theme }) => theme.menu.primaryTextColor};
    background:${({ theme }) => theme.menu.groupContentBackground};
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
&::placeholder{
  color:${({ theme }) => theme.menu.primaryTextColor};
  opacity:0.6;
}
`;
const GroupTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
  h1 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 32px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: center;
  }
  p {
    color:${({ theme }) => theme.menu.primaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: center;
  }
`;


const Content = styled.div`
 display: flex;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 32px;
  overflow: auto;
`;

const GroupDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: -10px;
  p{
  color:${({ theme }) => theme.menu.primaryTextColor};
  
  }
`;



const CancelBtn = styled.p`
 color: #b5b8cd;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    margin-bottom:20px;
`

const GroupDescriptionText = styled.p`
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;

`